import React from "react";

const AcaoJudicial = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Rota /acao-judicial funcionando ✅</h1>
    </div>
  );
};

export default AcaoJudicial;